import {useEffect, useState} from 'react';
import {Linking} from 'react-native';
import {getShareInfo, updateInviteCode} from './share.service';
import globalStore from '@/services/global.state';
import {copyText, errorLog, goTo, openShare} from '@/utils';
import i18n from '@/i18n';
import {ShareInfo} from '@/components/business/share-panel/share-panel-provider';
import {buildInviteShareUrl, webConfig} from '@/services/web-config.state';
import {getUrl as getScratchUrl} from '@/pages/new-scratch/const';

const makeShareMessage = (
  msg: string | null | undefined,
  inviteCode: string | null | undefined,
) => {
  const shareUrl = buildInviteShareUrl(webConfig.shareUrl, inviteCode || '');
  if (!shareUrl) {
    return '';
  }
  // inviteRegisterLinkUrl 可能缺失；空文案时仅拼接分享链接，避免 undefined.replace 崩溃
  return String(msg || '')
    .replace(/http(.*)$/g, '')
    .concat(shareUrl);
};

export function shareToPlatform(
  platform: string,
  link: string,
  tip: string = '',
) {
  if (!globalStore.token) {
    goTo('Login');
    return;
  }
  copyText(link);
  switch (platform) {
    case 'link':
    case 'CopyLink':
      globalStore.globalSucessTotal(i18n.t('share.copy-success'), tip);
      break;
    case 'Facebook':
      Linking.openURL('fb://messaging').catch(e => errorLog(e));
      break;
    case 'Telegram':
      Linking.openURL(`tg://msg_url?url=${encodeURIComponent(link)}`).catch(e =>
        errorLog(e),
      );
      break;
    case 'Whatsapp':
      Linking.openURL('https://wa.me?text=' + encodeURIComponent(link)).catch(
        e => errorLog(e),
      );
      break;
    case 'Instagram':
      Linking.openURL('instagram://media').catch(e => errorLog(e));
      break;
  }
}

export function useShare(autoInit = false) {
  const [code, setCode] = useState<string>('');
  const [invateText, setInviteText] = useState('');

  const copyCode = () => {
    if (!globalStore.token) {
      goTo('Login');
      return;
    }
    if (!code) {
      globalStore.globalWaringTotal(i18n.t('label.failed'));
      return;
    }
    copyText(code);
    globalStore.globalSucessTotal(i18n.t('share.copy-success'));
  };

  /**
   * 进行分享
   * @param info
   *
   */
  const doShare = (info: ShareInfo = {}) => {
    if (!globalStore.token) {
      goTo('Login');
      return;
    }
    const shareText = makeShareMessage(invateText, code);
    if (!shareText) {
      globalStore.globalWaringTotal(i18n.t('label.failed'));
      return;
    }
    copyText(shareText);
    if (openShare(shareText)) {
      return;
    }
    info.info = shareText;
    globalStore.shareProviderSubject.next(info);
  };

  const initShare = () => {
    return getShareInfo().then(data => {
      setCode(data?.inviteCode || '');
      // 优先用带链文案；缺失时回退 content，避免 invateText 为 undefined
      setInviteText(data?.inviteRegisterLinkUrl || data?.content || '');
    });
  };

  const refreshCode = async () => {
    await updateInviteCode();
    await initShare();
  };
  const shareGame = (info: ShareInfo = {}) => {
    if (!globalStore.token) {
      goTo('Login');
      return;
    }
    const shareText = getScratchUrl('/scratch-share', {code});
    if (!shareText) {
      return;
    }
    copyText(shareText);
    if (openShare(shareText)) {
      return;
    }
    info.info = shareText;
    globalStore.shareProviderSubject.next(info);
  };

  useEffect(() => {
    if (autoInit) {
      initShare();
    }
  }, [autoInit]);

  return {
    initShare,
    doShare,
    code,
    refreshCode,
    copyCode,
    shareGame,
  };
}
